import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {authApi} from '../../../core/api';
import {FaUser, FaLock} from "react-icons/fa";
import '../../styles/Login.css';
import {useAuth} from '../../../context/AuthContext';
import PageSpinner from "../../components/Spinner";
import {Spinner} from "react-bootstrap";
import { toast } from "react-toastify";
import { autofillOffProps } from "../../../shared/autofillOffProps";



const LoginPage = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');
    const [isAuthError, setIsAuthError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [pageLoading, setPageLoading] = useState(true);
    const navigate = useNavigate();


    useEffect(() => {
        setTimeout(() => {
            const msg = localStorage.getItem("logoutMessage");
            if (msg) {
                toast.error(msg, {
                    autoClose: 4000,
                    toastId: "session-expired"
                });
                localStorage.removeItem("logoutMessage");
            }
        }, 100);
    }, []);


    useEffect(() => {
        // Sayfa ve tüm kaynaklar tamamen yüklendiyse hemen göster
        if (document.readyState === 'complete') {
            setPageLoading(false);
        } else {
            // Yoksa yüklenince göster
            window.addEventListener('load', () => setPageLoading(false));
        }

        return () => {
            window.removeEventListener('load', () => setPageLoading(false));
        };
    }, []);







    const {login} = useAuth();

    const isDisabled = !username || !password || loading;

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await authApi.login({username, password});

            if (response.data && response.data.accessToken) {
                setMessage('');
                setIsAuthError(false);


                localStorage.setItem("refreshToken", response.data.refreshToken);

                login(response.data.user, response.data.accessToken, response.data.refreshToken);
                navigate('/index');

            } else {
                setIsAuthError(true);
                setMessage('Sunucudan geçersiz yanıt');
            }

        } catch (error) {
            const status = error?.response?.status;
            const msg = error?.response?.data?.message;

            if (status === 401 || msg?.toLowerCase().includes('invalid')) {
                setMessage('Hatalı giriş bilgileri.');
                setIsAuthError(true);
            } else {
                setMessage('Bilinmeyen bir hata oluştu.');
                setIsAuthError(false);
            }
        } finally {
            setLoading(false);
        }
    };

    if (pageLoading) {
        return (

            <PageSpinner/>
        );
    }


    return (

        <div className="login-page">
            <div className={"wrapper"}>
                <form onSubmit={handleLogin} autoComplete="off" data-lpignore="true">
                    <h1>Footex</h1>

                    <div className={"input-box"}>
                        <input
                            type="text"
                            placeholder="Kullanıcı İsmi"
                            id="username"
                            name="ftx-admin-user"
                            required
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            {...autofillOffProps}
                        />
                        <FaUser className={"login-icon"}/>
                    </div>

                    <div className={"input-box"}>
                        <input
                            type="password"
                            placeholder="Şifre"
                            id="password"
                            name="ftx-admin-pass"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            {...autofillOffProps}
                        />
                        <FaLock className={"login-icon"}/>
                    </div>

                    {/*<div className="remember-me">*/}
                    {/*    <label className="checkbox-label">*/}
                    {/*        <input type="checkbox"/>*/}
                    {/*        <span>Beni Hatırla!</span>*/}
                    {/*    </label>*/}
                    {/*</div>*/}

                    <button type="submit" disabled={isDisabled} className={isDisabled ? "btn-disabled" : ""}>
                        {loading ? (
                            <div className="d-flex align-items-center justify-content-center">
                                Giriş yapılıyor...
                                <Spinner size="sm" className="ml-2"/>
                            </div>


                        ) : (
                            "Giriş"
                        )}
                    </button>

                    {message && (
                        <div
                            style={{
                                marginTop: '10px',
                                color: isAuthError ? 'red' : '#e8c116',
                                fontSize: '18px',
                                textAlign: 'center'
                            }}
                        >
                            {message}
                        </div>
                    )}

                </form>
            </div>
        </div>

    );
};

export default LoginPage;
